<template>
	<v-card :elevation="1" class="round-card background-2" width="100%">
        <v-card-title class="pa-3">
			<v-badge v-model="filtered" color="primary" class="d-flex">
				<v-icon slot="badge" dark>filter_list</v-icon>
                <div>
                    <p class="pl-2 pl-xl-3">Mappa Cassoni</p>
                </div>
				<div>
					<span class="fs12 grey--text">&nbsp;{{ filterSelectedName }}</span>
				</div>
			</v-badge>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
            <gmh-date-picker
                v-model="search"
                label="Data"
                field-class="pr-4"
                hide-details
                :clearable="false"
            ></gmh-date-picker>

			<v-btn v-if="infoData.availableFilters" icon @click.native="showFilters = !showFilters" class="ml-1">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<span v-on="on">
							<v-icon :color="filtered ? 'primary' : 'dark'">{{ filtered ? 'filter_list' : 'filter_list' }}</v-icon>
						</span>
					</template>
					<span>Filtri avanzati</span>
				</v-tooltip>
			</v-btn>            
            
        </v-card-title>            
		<v-divider></v-divider>

		<advanced-filters
			v-if="infoData.availableFilters && $store.getters.isOnline"
			:infoAvailableFilters="infoData.availableFilters"
			modelDef="containermaps"
			:filtered.sync="filtered"
			:show-filters.sync="showFilters"
			:get-cache="getCache"
			:filter-selected.sync="filterSelected"
			:crudSearch="search"
		></advanced-filters>        
    
        <v-progress-linear indeterminate v-show="loading" value="15"></v-progress-linear>
        <v-col
            ref="googleMap"
            id="map"
            class="round-card"
            style="height: 75vh; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;">
        </v-col>
        <v-card
            id="legend"
            class="pa-4 pl-3 round-card background-1"
            style="border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important;">
        </v-card>
        
        <div id="map_canvas"></div>
        
    </v-card>
</template>

<script>

    import Vue from 'vue'
    import MapInfo from '@/components/modules/agribios/MapInfo'
    import GoogleMapsApiLoader from 'google-maps-api-loader'
    import HTMLMarker from '@/components/utilities/HTMLMarker.js'
    import { MarkerClusterer } from '@googlemaps/markerclusterer'

    import AdvancedFilters from '@/components/common/AdvancedFilters'

    export default {
		name: 'container-maps',
		components: {
			AdvancedFilters,
		},    
		props: {
        },
        data() {
			return {
                apiKey: 'AIzaSyBfzJUosHsruxGnozq51-cz7YkAbf4RhqA',
                locations: [],
                markers: {},
                markerClusterer: [],
                infoWindows: null,
                google: null,
                map: null,
                service: null,
                icons: null,
                mapConfig: {
                    center: { lat: 41.9102411, lng: 12.3955718 },
                    zoom: 10,
                    mapTypeId: 'roadmap',
                },
                debounceBounds: null,
                bounds: null,
                logoBase64: '',

				infoData: {},
				items: [],
                search: moment().format('YYYY-MM-DD'),
				loading: false,
				filtered: false,
				debouncer: {},
				advancedFilters: {},
				showFilters: false,
                filterSelected: {},
			}
		},

		watch: {
            search: {
                handler() {
                    this.removeMarkers()
                }
            },
        },        

		computed: {
			getCache() {
				return _.isEmpty(this.subFilters)
			},

			filterSelectedName() {
				if(this.filterSelected.title) {
					return '(' + this.filterSelected.title +')'
				} else {
					return ''
				}
			},
         
        },
        
        methods: {

            removeMarkers(callApi = true) {
                // this.markerClusterer.removeMarkers(Object.values(this.markers))
                this.$set(this, 'locations', null)
                _.forEach(this.markers, (marker, key) => {
                    this.markers[key].setMap(null)
                })
                this.google.maps.event.trigger(this.map, 'resize')
                this.$set(this, 'markers', {})     
                if(callApi) {
                    this.getDataFromApi(true)
                }           
            },

			getDataFromApi() {

                this.loading = true
                let dataObject = {
                    advancedFilters: this.advancedFilters,
                    filter: this.search,
                    location: true,
                    bounds: this.bounds
                }

                this.axios.post('containermaps-filters', dataObject).then(response => {
                    // get body data
                    this.locations = response.data.data
                    // create markers

                    this.locations.map((marker, key) => {
                        if(!this.markers[marker.id + '_' + marker.entity]) {
                            let m = new google.maps.Marker({
                                position: {
                                    'lat': parseFloat(marker.latitude),
                                    'lng': parseFloat(marker.longitude)
                                },
                                map: this.map,
                                icon: this.icons[marker.entity].icon
                            })
    
                            m.addListener('click', () => {
                                if(this.infoWindows) {
                                    this.infoWindows.close()
                                    this.$set(this, 'infoWindows', null)
                                } 
    
                                this.service.getDetails({placeId: marker.place_id, fields: ['photo', 'name', 'url', 'formatted_address'] }, (place, status) => {
                                    if (status == this.google.maps.places.PlacesServiceStatus.OK) {
                                        marker.url = place.url
                                        marker.full_address = place.formatted_address
                                        var photos = place.photos
                                        if (photos) {
                                            marker.photo = photos[0].getUrl()
                                        }
                                    }
    
                                    var InfoWindow = Vue.extend(MapInfo)
                                    var instance = new InfoWindow({
                                        propsData: {
                                            content: marker,
                                            apiKey: this.apiKey,
                                            router: this.$router
                                        }
                                    })
    
                                    instance.$mount()
                                    this.infoWindows = new google.maps.InfoWindow({
                                        content: instance.$el,
                                    })
                                    this.infoWindows.open(this.map, m)
                                })
                                
                            })
    
                            this.$set(this.markers, [marker.id + '_' + marker.entity], m)
                        }
                    })

                    // this.markerClusterer = new MarkerClusterer({ markers: Object.values(this.markers), map: this.map })
                    this.loading = false
                    this.$store.commit('endProgress')
                }, response => {
                    // error callback
                })                
			},  
            
            geolocate() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.$set(this.mapConfig.center, 'lat', position.coords.latitude)
                    this.$set(this.mapConfig.center, 'lng', position.coords.longitude)
                }, () => {
                    // geolocalizatio
                })
            },         
        },

		created() {

            this.axios.get('containermaps-info').then(response => {
                // get info data
                this.infoData = response.data.info

                this.$store.commit('endProgress')

            }, response => {
                // error callback
                this.loading = false
            })
            // this.$watch('search', this.getDataFromApi)
        },


        async mounted() {

            this.geolocate()
            let address_lat = this.$store.getters.getSetting('address_lat')
            let address_lng = this.$store.getters.getSetting('address_lng')
            
            this.mapConfig.center = {lat: address_lat, lng: address_lng}

            this.google = await GoogleMapsApiLoader({
                apiKey: this.apiKey,
                libraries: ['places']
            })

            const mapContainer = this.$refs.googleMap

            this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
            this.google.maps.event.trigger(this.map, 'resize')
            this.service = new this.google.maps.places.PlacesService(this.map)                


            const iconBase = '/img/icons/pin_'
            this.icons = {
                company: {
                    name: 'Azienda',
                    icon: iconBase + 'lead.svg',
                },
                destination: {
                    name: 'Destinazione',
                    icon: iconBase + 'prospect.svg',
                },
            }


            const legend = document.getElementById('legend')

            for (const key in this.icons) {
                const type = this.icons[key]
                const name = type.name
                const icon = type.icon
                const div = document.createElement('div')

                div.innerHTML = '<div style="display: flex; padding-bottom: 4px"><img style="width: 24px" src="' + icon + '"><div style="margin: auto;margin-left: 4px; font-size: 12px; font-weight: normal">' + name + '</div></div>';
                legend.appendChild(div)
            }

            this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend)
            
            // load more result whene move in maps
            this.map.addListener('bounds_changed', () => {
                if(this.debounceBounds) clearTimeout(this.debounceBounds)

                this.debounceBounds = setTimeout(() => {
                    this.bounds = this.map.getBounds().toJSON()
                    this.getDataFromApi()
                }, 500)
            })

            // event close info window
            this.$eventBusUtility.$on('closeInfoWindow', () => {
                this.infoWindows.close()
                this.$set(this, 'infoWindows', null)
            })

            this.$eventBusUtility.$on('filters_containermaps', (advancedFilters) => {
				this.advancedFilters = advancedFilters
                localStorage.setItem('crud_advancedFilters_containermaps', JSON.stringify(this.advancedFilters))
                this.removeMarkers()
            })
            
            if(address_lat && address_lng) {

                this.axios.get('get-logo').then(response => {

                    this.logoBase64 = response.data.logo
                    
                    HTMLMarker.prototype = new google.maps.OverlayView()
                    HTMLMarker.prototype.onRemove= function(){}
                    
                    //init html element
                    let logo = this.logoBase64
                    HTMLMarker.prototype.onAdd= function(){
                        var div = document.createElement('div')
                        div.classList.add('arrow_box', 'custom-avatar')
                        div.style.cssText = 'background-image: url("' + logo + '"); border-radius: 50% !important; background-size: contain !important; background-position: center !important'

                        var panes = this.getPanes()
                        panes.overlayImage.appendChild(div)
                    }
                    
                    HTMLMarker.prototype.draw = function(){
                        var overlayProjection = this.getProjection()
                        var position = overlayProjection.fromLatLngToDivPixel(this.pos)
                        var panes = this.getPanes()
                        panes.overlayImage.style.left = position.x + 'px'
                        panes.overlayImage.style.top = position.y - 30 + 'px'
                    }
                    
                    var htmlMarker = new HTMLMarker(address_lat, address_lng)
                    htmlMarker.setMap(this.map)

                }, response => {
                    // error callback
                })

            }

        },        
    }
</script>

<style>

</style>